import { LibraryDatasetTable } from '@/components'
import { config } from '@/config'
import { DatasetSimple } from '@/interfaces'

import { useLossFactors } from '../hooks'

interface Props {
  datasets: DatasetSimple[]
}

export const LossFactorsDatasetsTable = ({ datasets }: Props) => {
  const { cloneDataset, isCloneDatasetInProgress, removeDataset } =
    useLossFactors()

  const allDatasetNames = datasets.map(x => x.name || '')

  const handleCloneDataset = (
    datasetId: number,
    datasetName: string,
    onSuccess: () => void
  ) => {
    cloneDataset({ datasetId, name: datasetName }, { onSuccess })
  }

  return (
    <LibraryDatasetTable
      datasets={datasets}
      getDetailsLink={datasetId =>
        `${config.links.library.lossFactors}/${datasetId}`
      }
      isCloneInProgress={isCloneDatasetInProgress}
      onRemoveClicked={datasetId => removeDataset(datasetId)}
      onCloneClicked={handleCloneDataset}
      allDatasetNames={allDatasetNames}
    />
  )
}
